<template lang="pug">
  .b-group-children
    slot
</template>

<script>
import NodeHead from '@/components/node/NodeHead';

export default {
  name: 'NodesGroupChildren',
  components: { NodeHead },
};
</script>
